import React, { useCallback, memo, useState, useEffect } from 'react';
import './App.css';
import JobSearchRoadmap from './components/JobSearchRoadmap';
import Advertisement from './components/Advertisement';
import WelcomePopup from './components/WelcomePopup';
import { trackExternalLink } from './utils/analytics';
import SpotifyPopup from './components/SpotifyPopup';
import WhatsAppInvite from './components/WhatsAppInvite';

import useLocalStorage from './hooks/useLocalStorage';
import { trackPageView, trackSpotifyInteraction } from './utils/analytics';

function App() {
  // Use custom hook for localStorage
  const [hasVisitedBefore, setHasVisitedBefore] = useLocalStorage<boolean>('hasVisitedBefore', false);
  const [hasSeenSpotifyPopup, setHasSeenSpotifyPopup] = useLocalStorage<boolean>('hasSeenSpotifyPopup', false);
  
  // State for controlling popups
  const [showingWelcome, setShowingWelcome] = useState(!hasVisitedBefore);
  const [showingSpotify, setShowingSpotify] = useState(false);

  // Track page view on initial load
  useEffect(() => {
    trackPageView('/', 'Job Search Roadmap - Main Page');
  }, []);

  // Function to close the welcome popup and show Spotify popup
  const closeWelcomePopup = useCallback(() => {
    setShowingWelcome(false);
    setHasVisitedBefore(true);
    
    // Show Spotify popup if user hasn't seen it before
    if (!hasSeenSpotifyPopup) {
      setShowingSpotify(true);
      // Track Spotify popup view
      trackSpotifyInteraction('popup_view');
    }
  }, [setHasVisitedBefore, hasSeenSpotifyPopup]);

  // Function to close the Spotify popup
  const closeSpotifyPopup = useCallback(() => {
    setShowingSpotify(false);
    setHasSeenSpotifyPopup(true);
    // Track Spotify popup close
    trackSpotifyInteraction('popup_close');
  }, [setHasSeenSpotifyPopup]);

  const currentYear = new Date().getFullYear();

  return (
    <div className="App">
      {showingWelcome && <WelcomePopup onClose={closeWelcomePopup} />}
      {showingSpotify && <SpotifyPopup onClose={closeSpotifyPopup} />}
      
      <header className="App-header">
        <h1>מפת דרכים לחיפוש עבודה</h1>
        <p>מדריך אינטראקטיבי לתהליך חיפוש העבודה</p>
      </header>
      
      {/* Ad banner component that maintains state across routes */}
      <Advertisement />
      
      <div className="instructions">
        <p>לחץ על כל שלב כדי לראות מפת דרכים מפורטת</p>
      </div>
      <main>
        <JobSearchRoadmap />
      </main>
      <footer>
        <p>לחץ על כל צעד כדי להרחיב מידע | לחץ על שלב ראשי כדי להציג מפה מפורטת</p>
        <div className="footer-support">
          <p>אהבת את הכלי? תמוך בפיתוח נוסף:</p>
          <a 
            href="https://www.buymeacoffee.com/ALmogShtaigmann" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="bmc-button"            onClick={() => trackExternalLink('https://www.buymeacoffee.com/ALmogShtaigmann', 'support_button')}
          >
            <img 
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" 
              alt="Buy Me A Coffee" 
              className="bmc-button-img" 
            />
            <span>Buy me a coffee</span>
          </a>
        </div>
        <p>© {currentYear} Almog Shtaigmann. כל הזכויות שמורות.</p>
      </footer>
      
      {/* WhatsApp Invite Button */}
      <WhatsAppInvite 
        inviteLink="https://chat.whatsapp.com/HjchGqZ7Wo79txPJJBLclb" 
        tooltipText="סטודנט? מחפש משרה? הצטרפף לקבוצת הווטאספ עם מעל ל 300 אנשים, בקבוצה אני שולח משרות באופן יומי!" 
      />
    </div>
  );
}

export default memo(App);
